module.exports = __webpack_public_path__ + "img/sample-networkEngineer.338723ef.webp";